import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from './api';
import {
  DeleteTestList,
  GetTestListReferences,
  GetTestLists,
  ImportTestList,
} from '../../shared/api/definitions/testList';
import {ObjectId} from 'bson';

export const TestListQueryKeys = {
  all: ['testLists'] as const,
  references: (testListId: ObjectId) => [
    ...TestListQueryKeys.all,
    'references',
    testListId.toString(),
  ],
};

export const useGetTestLists = createApiQuery(
  GetTestLists,
  () => TestListQueryKeys.all
);

export const useDeleteTestList = () => {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteTestList, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TestListQueryKeys.all,
      });
    },
  });
};

export const useGetTestListReferences = createApiQuery(
  GetTestListReferences,
  ({testListId}) => TestListQueryKeys.references(testListId)
);

export const useImportTestList = () => {
  const queryClient = useQueryClient();
  return useApiMutation(ImportTestList, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TestListQueryKeys.all,
      });
    },
  });
};
